<div class="image-modal" (click)="close()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <button class="modal-close" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>

        <div class="modal-image-wrapper">
            <div class="vertical-blur-container">
                <div class="vertical-blur-content" [style.background-image]="'url(' + data.imageUrl + ')'"></div>
            </div>
            <img [src]="data.imageUrl" alt="Image agrandie" class="modal-image">
        </div>
        
        <!-- Navigation entre les images -->
        <div class="modal-navigation" *ngIf="data.allImages && data.allImages.length > 1">
            <button class="nav-button" (click)="previousImage()" *ngIf="currentIndex > 0">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <button class="nav-button" (click)="nextImage()" *ngIf="currentIndex < data.allImages.length - 1">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
    </div>
</div>